import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { useGeneralStore } from "%/stores/general-store";

export const useMyCollaboratorProposalFeedStore = defineSmartFeedPiniaStore(
  "my-collaborator-proposal-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        orgId: {
          key: "org_id",
          payload: useGeneralStore().orgId,
        },
      },
      tableFields: [
        { key: "publicationName", label: "Publication" },
        { key: "orgName", label: "Org Name" },
        { key: "status", label: "Proposal Status" },
        { key: "role", label: "Role" },
        { key: "actions", label: "" },
      ],
    }),
    getters: {
      feedUrl() {
        return `/collaborator/${useGeneralStore().orgId}/proposals`;
      },
    },
  },
);
